module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bdreconciliation"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("BD交易对账")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("对账筛选")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "40px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "text-align": "right",
      "margin-right": "10px"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.searchlist.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "phone_number", $$v)
      },
      expression: "searchlist.phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "40px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "text-align": "right",
      "margin-right": "10px"
    }
  }, [_vm._v("订单月份")]), _vm._v(" "), _c('a-month-picker', {
    attrs: {
      "placeholder": "Select month",
      "defaultValue": _vm.moment(_vm.searchlist.month)
    },
    on: {
      "change": _vm.onMonthChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "40px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "text-align": "right",
      "margin-right": "10px"
    }
  }, [_vm._v("结算状态")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.searchlist.status),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "status", $$v)
      },
      expression: "searchlist.status"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t全部\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "unclear"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t未结算\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "clear"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t已结算\n\t\t\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearchBD
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "contentcard",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-bottom": "70px"
    }
  }, [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信头像")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("交易月份")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("结算状态")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("操作")])], 1), _vm._v(" "), (_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "border-radius": "4px",
      "padding": "11px 0 0 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.bdlist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.bdlist), function(bd, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "min-height": "60px",
        "padding": "5px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(bd.nick_name))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      attrs: {
        "src": bd.avatar_url,
        "height": "56"
      }
    })]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(bd.phone_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(_vm.moment(_vm.searchlist.month).format('MMMM')))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(_vm.reconciliation_status(bd.reconciliation_status)))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "type": "primary",
        "ghost": "",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.gototrade(bd.id)
        }
      }
    }, [_vm._v("去对账")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.bdsum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)], 2)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30bfd3e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/bdreconciliation/index.vue
// module id = 2374
// module chunks = 1